<div class="idp-loader" *ngIf="show">
  <div class="idp-loader__overlay"></div>
  <div
    #spinnerLoad
    (keydown.shift.tab)="tabListener($event)"
    (keydown.tab)="tabListener($event)"
    class="idp-loader__loading"
    [attr.data-cy]="dataCy + '-holder'"
  >
    <div class="idp-loader__holder"></div>
    <h2
      *ngIf="spinnerLabel"
      role="alert"
      [attr.aria-hidden]="spinnerLabelHidden"
      [attr.data-cy]="dataCy"
    >
      {{ spinnerLabel }}
    </h2>
  </div>
  <span class="sr-only" aria-live="polite" role="alert">
    {{ spinnerLabel }}
  </span>
</div>
